import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import Spinner from "../../../theme/Spinner";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import "rsuite/DateRangePicker/styles/index.css";
import { getContactListApi } from "../../../services/super-admin-service/_contact";

const ContactList = () => {
  const [displayFilter, setDisplayFilter] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");
  const [records, setRecords] = useState([]);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [searchFilter, setSearchValue] = useState<string>("");
  const [dateRange, setDateRange] = useState(null);
  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };

  const getContactList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;
    if (isFilter) {
      if (searchFilter) {
        query += `&search=${searchFilter}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }

      if (dateRange) {
        query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
        query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
      }
    }
    const result: any = await getContactListApi(query);

    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setTotalRecords(result.data.total_records);
      setTotalPages(totalPagesCount);
      setRecords(result.data.records);
    }
    setLoading(false);
  };

  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getContactList(page, perPage, true, key, type);
  };

  useEffect(() => {
    if (page && perPage) {
      getContactList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  const filterList = async () => {
    setApplyFilter(true);
    setPage(1);
    getContactList(1, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);

    setDateRange(null);
    setSearchValue("");
    getContactList(page, perPage);
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>News Letter List</h5>
          </div>

          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
          </div>
        </div>
        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        htmlFor="date"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        News Letter Created Date:
                      </label>
                      <DateRangePicker
                        format="dd-MM-yyyy"
                        className="form-control"
                        placeholder="From Date ~ To Date"
                        value={dateRange}
                        onChange={(values: any) => {
                          setDateRange(values);
                        }}
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        htmlFor="search"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Search :
                      </label>
                      <input
                        type="text"
                        id="search"
                        className="form-control"
                        placeholder="Search..."
                        value={searchFilter}
                        onChange={(e) => setSearchValue(e.target.value)}
                      />
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={filterList}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-github ms-5"
                        onClick={resetList}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}
          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>

                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("email")}
                >
                  Email
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>

                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("firstName")}
                >
                  First Name
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>

                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("lastName")}
                >
                  Last Name
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("phoneNo")}
                >
                  Mobile Number
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("message")}
                >
                  Message
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>

                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("companyCreatedAt")}
                >
                  Created At
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((item: any, i: number) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * perPage + 1 + i}</td>

                    <td>{item.email ? item.email : "-"}</td>
                    <td>{item.firstName ? item.firstName : "-"}</td>
                    <td>{item.lastName ? item.lastName : "-"}</td>
                    <td>{item.phoneNo ? item.phoneNo : "-"}</td>
                    <td>{item.message ? item.message : "-"}</td>

                    <td>
                      {item?.createdAt
                        ? moment(item.createdAt).format("YYYY-MM-DD HH:mm:ss")
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} className="text-center">
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={records}
          prevButton={prevButton}
          nextButton={nextButton}
        />
      </div>
    </>
  );
};
export default ContactList;
